import { Navigate } from "react-router-dom";

import Dashboard from "../pages/Dashboard";

//Product
import ListView from "../pages/Products/ListView";
import GridView from "../pages/Products/GridView";
import Overview from "../pages/Products/Overview";
import CreateProduct from "../pages/Products/CreateProduct";
import Categories from "../pages/Products/Categories";
import SubCategories from "../pages/Products/SubCategories";

//designer
import DesignerList from "../pages/Designers/DesignerList";
import DesignerCreate from "../pages/Designers/DesignerCreate";
import DesignerEdit from "../pages/Designers/DesignerEdit";
//pages
import PageList from "../pages/PageSection/PageList";
import PageCreate from "../pages/PageSection/PageCreate";
import PageEdit from "../pages/PageSection/PageEdit";

//blogs
import BlogList from "../pages/Blogs/BlogList";
import BlogCreate from "../pages/Blogs/BlogCreate";
import BlogEdit from "../pages/Blogs/BlogEdit";

// Orders
import OrdersListView from "../pages/Orders/ListView";
import OrdersOverview from "../pages/Orders/Overview";

// Calender
import Calendar from "../pages/Calendar";

// Sellers
import SellersListView from "../pages/Sellers/ListView";
import SellersGridView from "../pages/Sellers/GridView";
import SellersOverview from "../pages/Sellers/Overview";

// Invoice
import InvoiceList from "../pages/Invoices/InvoiceList";
import InvoiceDetails from "../pages/Invoices/InvoiceDetails";
import CreateInvoice from "../pages/Invoices/CreateInvoice";

// User List
import UsersList from "../pages/UsersList";

// Shipping
import Shipments from "../pages/Shipping/Shipments";
import ShippingList from "../pages/Shipping/ShippingList";

// Coupons
import Coupons from "../pages/Coupons";
import Color from "../pages/Color/Color";

//Banner Settings
// import SliderOne from "../pages/SliderOne/SliderOne"
// import SliderTwo from "../pages/SliderTwo/SliderTwo"
// import OfferSection from "../pages/OfferSection/OfferSection"
// import MobileSlider from "../pages/MobileSlider/MobileSlider";
// import MobileSliderAdd from "../pages/MobileSlider/MobileSliderAdd";

//Review & Rating
import ReviewRating from "../pages/Reviews-Rating";

//Brands
import Brands from "../pages/Brands";

//statistics
import Statistics from "../pages/Statistics";

// Localization
import Transactions from "../pages/Localization/Transactions";
import CurrencyRates from "../pages/Localization/CurrencyRates";

// Accounts
import MyAccount from "../pages/Accounts/MyAccount";
import Settings from "../pages/Accounts/Settings";
import SignUp from "../pages/Accounts/AuthenticationInner/SignUp";
import SignIn from "../pages/Accounts/AuthenticationInner/SignIn";
import PasswordReset from "../pages/Accounts/AuthenticationInner/PasswordReset";
import PasswordCreate from "../pages/Accounts/AuthenticationInner/PasswordCreate";
import SuccessMessage from "../pages/Accounts/AuthenticationInner/SuccessMessage";
import TwoStepVerify from "../pages/Accounts/AuthenticationInner/TwoStepVerify";
import BasicLogout from "../pages/Accounts/AuthenticationInner/Logout";
import Error404 from "../pages/Accounts/AuthenticationInner/Error404";
import Error500 from "../pages/Accounts/AuthenticationInner/Error500";
import ComingSoon from "../pages/Accounts/AuthenticationInner/ComingSoon";

// Authentication
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgotPassword from "../pages/Authentication/ForgotPassword";
import UserProfile from "../pages/Authentication/user-profile";
import Sizelist from "../pages/Size/Sizelist";
import ReviewsRating from "../pages/Reviews-Rating/Reviews&Rating";
import AdminList from "../pages/Accounts/Settings/AdminList";
import Specificationlist from "../pages/Specifications/Specificationlist";
import FaqSection from "../pages/Faq/FaqSection";
import CreateFaq from "../pages/Faq/CreateFaq";
import BannerSection from "../pages/BannerSection/BannerSection";
import BannerSection1 from "../pages/BannerSection1/BannerSection";

import CreateReturnPolicy from "../pages/Return_Exchange/CreateReturnPolicy";
import CreateTermsCondition from "../pages/Terms_Condition/CreateTermsCondition";
import AddCoupon from "../pages/Coupons/AddCoupon";
import NewsLetterList from "../pages/NewsLetter/NewsLetterList";

const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },

  //Product
  { path: "/products-list", component: <ListView /> },
  { path: "/products-grid", component: <GridView /> },
  { path: "/product-overview", component: <Overview /> },
  { path: "/product-create", component: <CreateProduct key={1} /> },
  { path: "/product-edit/:productId", component: <CreateProduct key={2} /> },

  { path: "/categories", component: <Categories /> },
  { path: "/sub-categories", component: <SubCategories /> },

  //designer
  { path: "/designer-list", component: <DesignerList /> },
  { path: "/designer-create", component: <DesignerCreate /> },
  { path: "/designer-edit/:id", component: <DesignerEdit /> },
  // pages
  { path: "/page-list", component: <PageList /> },
  { path: "/page-create", component: <PageCreate /> },
  { path: "/page-edit/:id", component: <PageEdit /> },

  //blogs
  { path: "/blog-list", component: <BlogList /> },
  { path: "/blog-create", component: <BlogCreate /> },
  { path: "/blog-edit/:id", component: <BlogEdit /> },

  // Orders
  { path: "/orders-list-view", component: <OrdersListView /> },
  { path: "/orders-overview/:id", component: <OrdersOverview /> },

  // Sellers
  { path: "/sellers-list-view", component: <SellersListView /> },
  { path: "/seller-grid-view", component: <SellersGridView /> },
  { path: "/seller-overview", component: <SellersOverview /> },

  // Invoice
  { path: "/invoices-list", component: <InvoiceList /> },
  { path: "/invoices-details", component: <InvoiceDetails /> },
  { path: "/invoices-create", component: <CreateInvoice /> },

  // User List
  { path: "/users-list", component: <UsersList /> },

  // Shipping
  { path: "/shipping-list", component: <ShippingList /> },
  { path: "/shipments", component: <Shipments /> },
  // Master Setting
  { path: "/color", component: <Color /> },
  { path: "/size", component: <Sizelist /> },
  { path: "/specifications", component: <Specificationlist /> },
  { path: "/faq", component: <FaqSection /> },
  { path: "/createFaq", component: <CreateFaq /> },
  // { path: "/banner", component: <BannerSection1 /> },

  { path: "/return&ExchangePolicy", component: <CreateReturnPolicy /> },
  { path: "/terms&Condition", component: <CreateTermsCondition /> },
  { path: "/newsLetters", component: <NewsLetterList /> },

  // Banner Setting
  {
    path: "/banner/slider1",
    component: <BannerSection sliderID={"slider1"} />,
  },
  {
    path: "/banner/slider2",
    component: <BannerSection sliderID={"slider2"} />,
  },
  {
    path: "/banner/mobileSlider",
    component: <BannerSection sliderID={"mobileSlider"} />,
  },
  {
    path: "/banner/bannerSection",
    component: <BannerSection sliderID={"bannerSection"} />,
  },
  // { path: "/banner", component: <Duplicate /> },

  // { path: "/offerSection", component: <OfferSection /> },
  // { path: "/mobileSliderAdd", component: <MobileSliderAdd /> },

  // Coupons
  { path: "/coupons", component: <Coupons /> },

  { path: "/coupons/add-coupon", component: <AddCoupon key={1} /> },
  { path: "/coupons/add-coupon/:id", component: <AddCoupon key={2} /> },

  { path: "/calendar", component: <Calendar /> },

  //Review & Rating
  { path: "/reviews-ratings", component: <ReviewRating /> },
  { path: "/reviews-ratingsdetails/:id", component: <ReviewsRating /> },

  //Review & Rating
  { path: "/brands", component: <Brands /> },

  //statistics
  { path: "/statistics", component: <Statistics /> },

  // Localization
  { path: "/transactions", component: <Transactions /> },
  { path: "/currency-rates", component: <CurrencyRates /> },

  // Accounts
  { path: "/account", component: <MyAccount /> },
  { path: "/settings", component: <Settings /> },
  { path: "/admin-list", component: <AdminList /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  { path: "/", exact: true, component: <Navigate to="/dashboard" /> },
  { path: "*", component: <Navigate to="/dashboard" /> },
  { path: "/user-profile", component: <UserProfile /> },
];

const publicRoutes = [
  // Authentication
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/register", component: <Register /> },
  { path: "/forgot-password", component: <ForgotPassword /> },

  // AuthenticationInner
  { path: "/auth-signup-basic", component: <SignUp /> },
  { path: "/auth-signin-basic", component: <SignIn /> },
  { path: "/auth-pass-reset-basic", component: <PasswordReset /> },
  { path: "/auth-pass-change-basic", component: <PasswordCreate /> },
  { path: "/auth-success-msg-basic", component: <SuccessMessage /> },
  { path: "/auth-twostep-basic", component: <TwoStepVerify /> },
  { path: "/auth-logout-basic", component: <BasicLogout /> },
  { path: "/auth-404", component: <Error404 /> },
  { path: "/auth-500", component: <Error500 /> },
  { path: "/coming-soon", component: <ComingSoon /> },
];

export { authProtectedRoutes, publicRoutes };
